import React, { useState, useEffect } from "react";
import ZodiacSignCard from "./ZodiacSignCard";
import { signs } from "../data/signs";

function ZodiacSignContainer() {
  const AZTRO_API_KEY = process.env.REACT_APP_AZTRO_API_KEY;

  const [forcast, setForcast] = useState([]);
  const [zodiacSignsDetails, setZodicaSignsDetails] = useState([]);

  let count = -1;

  const zodiacSigns = zodiacSignsDetails.map((sign) => {
    count++;
    return (
      <ZodiacSignCard
        sign={sign.englishName}
        img={sign.image}
        key={sign.sign}
        forcast={forcast[count]}
      />
    );
  });

  useEffect(() => {
    signs.forEach((sign) => {
      fetch(
        `https://sameer-kumar-aztro-v1.p.rapidapi.com/?sign=${sign.englishName}&day=today`,
        {
          method: "POST",
          headers: {
            "x-rapidapi-host": "sameer-kumar-aztro-v1.p.rapidapi.com",
            "x-rapidapi-key": AZTRO_API_KEY,
          },
        }
      )
        .then(function (res) {
          setZodicaSignsDetails((zodiacSignsDetails) => [
            ...zodiacSignsDetails,
            sign,
          ]);
          if (res.ok) {
            return res.json();
          }
        })
        .then((value) => {
          setForcast((forcast) => [...forcast, value.description]);
        })
        .catch((err) => {
          console.log(err);
        });
    });
  }, []);

  return (
    <div className="container">
      <div className="row">{zodiacSigns}</div>
    </div>
  );
}

export default ZodiacSignContainer;
